import React, {useEffect, useState} from 'react';
import axios from "axios"
import "./AdminCom.css"
const Users = () => {

    const [data, setData] = useState([])
    const [userNameEdit, setUserNameEdit] = useState("")
    const [userImgEdit, setUserImgEdit] = useState("")

    const getApi = () => {
        axios
            .get("https://kudapizza.herokuapp.com/pizzas/")
            .then((res) => setData(res.data))
            .catch((err) => {
                console.log(err)
            })
    }
    useEffect(() => {
        getApi()
    }, [])

    const AdminDelete = async (id) => {
        try {
            const res = await axios
                .delete(`https://kudapizza.herokuapp.com/pizzas/${id}`)
                .then(() => window.location.reload());
            console.log("Data deleted");
        } catch (error) {
            alert(error);
        }
    };

    const EditPost = async (id) => {
        try {
            const res = await axios.put(`https://kudapizza.herokuapp.com/pizzas/${id}/`, {
                name_en: userNameEdit,
                image: userImgEdit,
            })
                .then(() => window.location.reload());
            console.log("Data ");
        } catch (error) {
            alert(error)
        }
    }
    return (

        <div className="main__users">
            <h1 className="h1">Change or Delete Products:</h1>
            <div className="forms">
                <input className="input" placeholder="    name" type="text" value={userNameEdit}
                       onChange={(e) => setUserNameEdit(e.target.value)}/>
                <input className="input" placeholder="    img" type="text" value={userImgEdit}
                       onChange={(e) => setUserImgEdit(e.target.value)}/>
                <h1 className="h1">Products:</h1>
            </div>
            <div className="Grid card-Img">

                {data.map((el) => {
                    return (
                        <div  key={el.id}>
                            <div  className="div">
                                <h3>{el.name_en}</h3>
                                <div>
                                    <img className="img-fluid" src={el.image} alt=""/>
                                    <div className="btns">
                                        <button className="glow_on_hover" onClick={() => AdminDelete(el.id)}>Delete
                                        </button>
                                        <button disabled={!userImgEdit} className="glow_on_hover"
                                                onClick={() => EditPost(el.id)}>Put
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

        </div>
    )

}


export default Users;